import { useState } from "react";
import { Helmet } from "react-helmet";
import { useParams } from "react-router-dom";
import dayjs from "dayjs";
import { useGetMeQuery, useGetTournamentQuery } from "generated/graphql";
import NavBar from "components/navbar/NavBar";
import SideBar from "components/sidebar/Sidebar";
import Modal from "components/Modal";
import RegistrationModal from "components/tournament/RegistrationModal";
import TournamentInfo from "components/tournament/TournamentInfo";
import LeaderboardTable from "components/tournament/LeaderboardTable";
import TournamentPageWrapper, { Tabs } from "components/tournament/TournamentPageWrapper";
import LiveSection from "components/tournament/LiveSection";
import Auth from "lib/auth";
import TournamentPageNavigation from "components/tournament/TournamentPageNavigation";
import TournamentRegistrations from "components/tournament/TournamentRegistrations";

const auth = new Auth();

const calculateDateDifference = (
  comparisonDate: string,
  comparisonPeriod: any = "day",
  comparisonDateFormat: string = "YYYY-MM-DD"
) =>
  dayjs().diff(dayjs(comparisonDate, comparisonDateFormat), comparisonPeriod);

function TournamentPage() {
  // @ts-ignore
  let { tournamentId } = useParams();

  // Queries and Mutations
  const {
    data: tournamentData,
    loading: loadingTournament,
    error: tournamentError,
  } = useGetTournamentQuery({
    variables: { tournamentId },
    nextFetchPolicy: "cache-first",
  });

  if (tournamentError) {
    auth.clearToken();
    document.location.reload();
  }

  const { data, loading } = useGetMeQuery({ nextFetchPolicy: "cache-first" });

  const [showModal, setModalVisibility] = useState(false);
  const [activeSection, setActiveSection] = useState< "info" | "registered" | "live" | "leaderboard">("info");
  const [isJustRegistered, setIsJustRegistered] = useState(false);

  let tournamentDetailsMap = {};
  let tournamentParticipants = [];
  if (!loadingTournament && tournamentData?.tournament) {
    tournamentDetailsMap = tournamentData?.tournament.tournamentDetails
      .map(({ key, value }: any) => ({
        [key]: value,
      }))
      // @ts-ignore
      .reduce((acc, val) => ({ ...acc, ...val }), {});
    tournamentParticipants = tournamentData?.tournament.participants.map(
      ({ party_id }) => party_id
    );
    tournamentParticipants.push(
      ...tournamentData.tournament.participants
        .map((team) =>
          team.party.party_relationships.map((party) => party.participant)
        )
        .reduce((acc, val) => [...acc, ...val], [])
    );
  }

  return (
    <TournamentPageWrapper>
      <Helmet>
        {!loadingTournament && (
          <title>{tournamentData?.tournament?.name!} — Jiwe eSports</title>
        )}
      </Helmet>
      <div className="wrapper">
        <SideBar
          nickname={data?.me?.nickname}
          isLoggedIn={!!data?.me?.nickname}
        />
        {!loading && data && (
          <NavBar nickname={data?.me?.nickname} name={data.me?.name} />
        )}
      </div>

      {showModal && (
        <Modal closeModal={() => setModalVisibility(false)}>
          <RegistrationModal
            setModalVisibility={setModalVisibility}
            membersInExistingTournamentTeams={tournamentParticipants}
            teamId={data?.me?.id!}
            tournamentId={tournamentId}
            tournamentData={tournamentData}
            tournamentDetailsMap={tournamentDetailsMap}
            setIsJustRegistered={setIsJustRegistered}
          />
        </Modal>
      )}

      {!loadingTournament && (
        <>
          <div className="container2">
            <div className="profile_parent">
              <img
                className="profile_cover_photo"
                src="/images/wzstill.jpg"
                alt=""
              />
              <p className="ph1">{tournamentData?.tournament?.name}</p>
              <div className="game_info_pic">
                <img
                  src={tournamentData?.tournament?.game.poster_url!}
                  alt=""
                />
              </div>
            </div>
          </div>

          <TournamentPageNavigation
            calculateDateDifference={calculateDateDifference}
            tournamentData={tournamentData}
            setActiveSection={setActiveSection}
            activeSection={activeSection}
            tournamentDetailsMap={tournamentDetailsMap}
          />

          <Tabs>
            {activeSection === "info" && (
              <TournamentInfo
                tournamentParticipants={tournamentParticipants}
                calculateDateDifference={calculateDateDifference}
                tournamentData={tournamentData}
                tournamentDetailsMap={tournamentDetailsMap}
                setModalVisibility={setModalVisibility}
                loggedInParty={data?.me?.id}
                isJustRegistered={isJustRegistered}
              />
            )}

            {activeSection === "registered" && (
              <TournamentRegistrations
                tournamentData={tournamentData}
                tournamentDetailsMap={tournamentDetailsMap}
              />
            )}

            {activeSection === "leaderboard" &&
              calculateDateDifference(
                tournamentData?.tournament?.tournamentDate[0]
              ) >= 0 && (
                <LeaderboardTable
                  tournamentId={tournamentId}
                  // @ts-ignore
                  leaderboardData={tournamentData?.tournament?.results!}
                />
              )}

            {activeSection === "live" &&
              // calculateDateDifference(
              //   tournamentData?.tournament?.tournamentDate[0]
              // ) === 0 &&
              //@ts-ignore
              tournamentDetailsMap["liveEventId"] && (
                <LiveSection
                  liveEventId={
                    // @ts-ignore
                    tournamentDetailsMap["liveEventId"]
                  }
                />
              )}
          </Tabs>
        </>
      )}
    </TournamentPageWrapper>
  );
}

export default TournamentPage;
